import { render } from "./accueil_contenu.vue?vue&type=template&id=68a2ee14"
import script from "./accueil_contenu.vue?vue&type=script&lang=js"
export * from "./accueil_contenu.vue?vue&type=script&lang=js"

import "./accueil_contenu.vue?vue&type=style&index=0&id=68a2ee14&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__